import script from "./User.vue?vue&type=script&setup=true&lang=js"
export * from "./User.vue?vue&type=script&setup=true&lang=js"

import "./User.vue?vue&type=style&index=0&id=26034750&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26034750"]])

export default __exports__